import React, { Component } from 'react';

class HomePanel extends Component {

    render() {
        return (
            <div id="homePanel">
                <p>HomePanel</p>
            </div>
        );
    }
}

export default HomePanel;
